export const MENU = 'menu';
export const MENU_ITEM = 'menuItem';
export const MENU_ITEMS_DETAIL = 'menuItemsDetail';
export const PRODUCT_PREVIEW = 'product_preview';
